
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/generative-ai",
      function () {
        return require("private-next-pages/features/generative-ai.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/generative-ai"])
      });
    }
  